import React from 'react';
import useStyles from './styles';
import SingleOptionItem from './SingleOptionItem';
import Divider from '../Divider/Divider';

function SingleOptionList({ items, onSelect, selectedIndex }: SingleOptionListProps) {
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <SingleOptionItem
            data-testid={item['data-testid']}
            title={item.title}
            subtitle={item.subtitle}
            secondSubtitle={item.secondSubtitle}
            selected={index === selectedIndex}
            left={item.left}
            onClick={() => {
              onSelect(index);
            }}
          />
          <Divider />
        </React.Fragment>
      ))}
    </ul>
  );
}

export default SingleOptionList;
